// src/seo/ContactSEO.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

export default function ContactSEO() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "Madeshwara Ambulance Services",
    "url": "https://madeshwaraambulance.com/contact",
    "logo": "https://madeshwaraambulance.com/assets/logo.png",
    "description": "Contact Madeshwara Ambulance for 24/7 emergency and non-emergency ambulance services in Bangalore and Karnataka.",
    "telephone": "+91 98459 74238",
    "email": "madeshwaraa@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "No.9/8, Near Swimming Pool, 1st Main Road, 1st Block East, Byrasandra, Jayanagar-560011",
      "addressLocality": "Bangalore",
      "addressRegion": "Karnataka",
      "postalCode": "560011",
      "addressCountry": "IN"
    },
    "openingHours": "Mo,Tu,We,Th,Fr,Sa,Su 00:00-23:59"
  };

  return (
    <Helmet>
      <title>Contact Madeshwara Ambulance | 24/7 Emergency Ambulance</title>
      <meta name="description" content="Get in touch with Madeshwara Ambulance for emergency or patient transport services across Bangalore and Karnataka." />
      <meta name="keywords" content="contact ambulance Bangalore, Madeshwara ambulance contact, emergency ambulance phone number" />
      <meta property="og:title" content="Contact Madeshwara Ambulance | 24/7 Emergency Ambulance" />
      <meta property="og:description" content="Reach Madeshwara Ambulance for fast and reliable emergency ambulance services in Bangalore." />
      <meta property="og:image" content="/assets/contact-og.jpg" />
      <meta property="og:url" content="https://madeshwaraambulance.com/contact" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Contact Madeshwara Ambulance | 24/7 Emergency Ambulance" />
      <meta name="twitter:description" content="Contact us for fast, safe, and reliable ambulance services in Bangalore and Karnataka." />
      <meta name="twitter:image" content="/assets/contact-og.jpg" />
      <link rel="canonical" href="https://madeshwaraambulance.com/contact" />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
